export const formatDate = (date: string) => {
  if (!date || date === '') {
    return null;
  }

  let separator = '-';
  if (date.includes('/')) {
    separator = '/';
  }

  const parts = date.split(separator);
  const year = parts[0];
  const month = parts[1];
  const day = parts[2];
  return `${day}-${month}-${year}`;
}